import About from "./about"
import Contact from "./contact";
import Hero from "./hero"
import Projects from "./projects";

const Home = () => {

    return(
        <>
            <Hero />
            <Projects />
            <About />
            <Contact />
        </>
    )
}
export default Home;